<template>
  <section class="section container pt-0">
    <transactions-datatable />
  </section>
</template>

<script>
import TransactionsDatatable from "./transactions_datatable/Index.vue";

export default {
  name: "VisanetPaymentIndex",
  components: {
    TransactionsDatatable,
  },
  data() {
    return {};
  },
  methods: {
    retrieve_settings() {
      // get_configuration(this)
      //   .then((conf) => {
      //     console.log("configuration retrieved", conf);
      //   })
      //   .catch((error) => {
      //     console.error(error);
      //   });
    },
    create() {
      console.log("create order");
    },
    refresh() {
      console.log("refresh orders");
    },
  },
  mounted() {},
  created() {},
};
</script>

<style scoped></style>
